export type TmpCookiesObj =
	| { [key: string]: string }
	| Partial<{ [key: string]: string }>;
